import { Checkbox, Stack, Typography } from '@mui/material';

export default function ChannelTag({ title, onToggle, isChecked, isDisabled }) {
	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="center"
			spacing={1}
			sx={{
				padding: '4px 10px',
				width: 'fit-content',
				maxWidth: '100%',
			}}
		>
			<Checkbox
				size="small"
				checked={isChecked}
				onChange={onToggle}
				disabled={isDisabled}
			/>
			<Typography
				sx={{
					fontSize: '14px',
					color: '#000000DE',
					fontWeight: 400,
					fontFamily: 'Roboto, sans-serif',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					maxWidth: '120px',
				}}
				title={title}
			>
				{title}
			</Typography>
		</Stack>
	);
}
